var _defs, _animateTransform, _animate, _animateTransform2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavenetAnimatedLoader3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "8%",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg316",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 2084 1670",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9874"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7758"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#ea6219",
    d: "M -0.5 -0.5 C 29.1667 -0.5 58.8333 -0.5 88.5 -0.5 C 371.5 556.167 654.5 1112.83 937.5 1669.5 C 907.833 1669.5 878.167 1669.5 848.5 1669.5 C 565.739 1113.64 282.739 557.976 -0.5 2.5 C -0.5 1.5 -0.5 0.5 -0.5 -0.5 Z",
    id: "path8565"
  }), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "auto",
    type: "scale",
    values: "0 0;1 1;1 1;1 1",
    calcMode: "spline",
    keyTimes: "0;0.28571428571428575;0.5714285714285715;1",
    keySplines: ".25 0 .75 .75;.25 0 .75 .75;.25 0 .75 .75",
    dur: "0.7s",
    begin: "0s",
    repeatCount: "indefinite",
    additive: "sum",
    accumulate: "none",
    fill: "freeze",
    id: "animateTransform3809"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1448",
    transform: "matrix(1 0 0 1 1089.173993061836 550.8986129888497)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#fefffe",
    d: "M 2083.5 2.5 C 2083.5 3.16667 2083.5 3.83333 2083.5 4.5 C 1906.63 351.897 1729.47 699.231 1552 1046.5 C 1440.59 828.01 1328.92 609.677 1217 391.5 C 1106.33 610.18 995.161 828.513 883.5 1046.5 C 705.578 698.99 527.911 351.323 350.5 3.5 C 419.401 2.16894 488.234 2.16894 557 3.5 C 666.016 226.198 775.016 448.864 884 671.5 C 994.745 453.677 1105.74 236.011 1217 18.5 C 1328.92 236.01 1440.59 453.677 1552 671.5 C 1660.33 448.833 1768.67 226.167 1877 3.5 C 1945.76 2.50196 2014.6 2.16863 2083.5 2.5 Z",
    id: "path245",
    transform: "matrix(1 0 0 1 -1089.173993061836 -550.8986129888497)"
  }, _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    attributeType: "auto",
    attributeName: "fill",
    values: "#1a232b;#1a232b;#1a232b",
    calcMode: "spline",
    keyTimes: "0;0.5714285714285715;1",
    keySplines: ".5 0 .5 .5;.5 0 .5 .5",
    dur: "0.7s",
    begin: "0s",
    repeatCount: 1,
    additive: "replace",
    accumulate: "none",
    fill: "freeze",
    id: "animate7654"
  }))), _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "auto",
    type: "scale",
    values: "0 0;1 1;1 1",
    calcMode: "spline",
    keyTimes: "0;0.5714285714285715;1",
    keySplines: ".25 0 .75 .75;.25 0 .75 .75",
    dur: "0.7s",
    begin: "0s",
    repeatCount: "indefinite",
    additive: "sum",
    accumulate: "none",
    fill: "freeze",
    id: "animateTransform3031"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavenetAnimatedLoader3);
export default __webpack_public_path__ + "static/media/wavenet-animated-loader3.8fa969400cf26662de74fcc200af097c.svg";
export { ForwardRef as ReactComponent };